export class LocalStorageKeys {
  public readonly AuthToken = 'authToken'
  public readonly RefreshToken = 'refreshToken'
  public readonly UserName = 'userName'
  public readonly SidebarOpen = 'sidebarOpen'
  public readonly CollectionsExplorerOpen = 'collectionsExplorerOpen'
  public readonly TypeExplorerOpen = 'typeExplorerOpen'
  public readonly LastOpenedCollection = 'lastOpenedCollection'
  public readonly NewItemButton_LastSelectedType = 'newItemButton_LastSelectedType'
  public readonly IsLightTheme = 'isLightTheme'
  public readonly CollectionTabPrefix = 'selectedTab-collection-'
  public readonly CollapsedFolderIds = 'collapsedFolderIds'
  public readonly SidebarWidth = 'sidebarWidth'
  public readonly RightPanelWidth = 'rightPanelWidth'
}

export const localStorageKeys = new LocalStorageKeys()
